import React, {useState} from "react";
import { useNavigate } from 'react-router-dom';
import Modal from './components/Modal';
import CreateResiProperty from "./CreateResiProperty";
import CreateVehicle from "./CreateVehicle";

const CreatePhysical = ({ isOpen = true, onClose }) => {
  const [assetType, setAssetType] = useState('residential_property'); // default
  const navigate = useNavigate();

  const handleAssetTypeChange = (e) => {
    setAssetType(e.target.value);
  };

  const handleClose = () => {
    if (onClose) onClose();
    else navigate(-1);
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Create New Physical Asset" width={900}>
      <label htmlFor="assetType" className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>Physical Asset Type: </label>
      <select
          id="assetType" value={assetType}
          onChange={handleAssetTypeChange}
          className="form-control d-inline-block"
          style={{ marginLeft: '10px', width: 'calc(100% - 220px)' }}>
        <option value="residential_property">Residential Property</option>
        <option value="vehicle">Vehicle</option>
      </select>

      {assetType === 'residential_property' && <CreateResiProperty />}
      {assetType === 'vehicle' && <CreateVehicle />}
    </Modal>
  );
};

export default CreatePhysical;

// const CreatePhysical = () => {
    // // State to hold form values
    // const [assetType, setAssetType] = useState('');
    // const [description, setDescription] = useState('');
    // const [financingSource, setFinancingSource] = useState('');
    // const [additionalInfo, setAdditionalInfo] = useState({}); // For dynamic fields
    // const history = useHistory();
    //
    // // Handle submitting the form
    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     try {
    //         const response = await axios.post('/api/assets/physical_assets/', {
    //             type: assetType,
    //             description: description,
    //             financing_source: financingSource,
    //             ...additionalInfo
    //         });
    //         // Redirect after creation
    //         history.push('/assets/physical_assets');
    //     } catch (error) {
    //         console.error("There was an error creating the asset:", error);
    //     }
    // };
    //
    // // Function to handle changes in the asset type dropdown
    // const handleAssetTypeChange = (e) => {
    //     const selectedType = e.target.value;
    //     setAssetType(selectedType);
    //
    //     // Set additional fields based on asset type
    //     // Example structure for each asset type, customize this based on your needs
    //     switch (selectedType) {
    //         case 'residential_property':
    //             setAdditionalInfo({bedrooms: '', bathrooms: '', squareFootage: ''});
    //             break;
    //         case 'vehicle':
    //             setAdditionalInfo({make: '', model: '', year: '', mileage: ''});
    //             break;
    //         default:
    //             setAdditionalInfo({});
    //             break;
    //     }
    // };
    //
    // return (
    //     <div>
    //         <h1>Add New Physical Asset</h1>
    //         <form onSubmit={handleSubmit}>
    //             <div>
    //                 <label>Physical Asset Type:</label>
    //                 <select value={assetType} onChange={handleAssetTypeChange} required>
    //                     <option value="">Select...</option>
    //                     <option value="residential_property">Residential Property</option>
    //                     <option value="vehicle">Vehicle</option>
    //                     {/* Add more asset types as needed */}
    //                 </select>
    //             </div>
    //
    //             <div>
    //                 <label>Description:</label>
    //                 <input
    //                     type="text"
    //                     value={description}
    //                     onChange={(e) => setDescription(e.target.value)}
    //                     required
    //                 />
    //             </div>
    //
    //             <div>
    //                 <label>Financing Source:</label>
    //                 <input
    //                     type="text"
    //                     value={financingSource}
    //                     onChange={(e) => setFinancingSource(e.target.value)}
    //                     required
    //                 />
    //             </div>
    //
    //             {/* Conditional fields based on asset type selection */}
    //             {assetType === 'residential_property' && (
    //                 <div>
    //                     <label>Bedrooms:</label>
    //                     <input
    //                         type="number"
    //                         value={additionalInfo.bedrooms}
    //                         onChange={(e) => setAdditionalInfo({...additionalInfo, bedrooms: e.target.value})}
    //                     />
    //
    //                     <label>Bathrooms:</label>
    //                     <input
    //                         type="number"
    //                         value={additionalInfo.bathrooms}
    //                         onChange={(e) => setAdditionalInfo({...additionalInfo, bathrooms: e.target.value})}
    //                     />
    //
    //                     <label>Square Footage:</label>
    //                     <input
    //                         type="number"
    //                         value={additionalInfo.squareFootage}
    //                         onChange={(e) => setAdditionalInfo({...additionalInfo, squareFootage: e.target.value})}
    //                     />
    //                 </div>
    //             )}
    //
    //             {assetType === 'vehicle' && (
    //                 <div>
    //                     <label>Make:</label>
    //                     <input
    //                         type="text"
    //                         value={additionalInfo.make}
    //                         onChange={(e) => setAdditionalInfo({...additionalInfo, make: e.target.value})}
    //                     />
    //
    //                     <label>Model:</label>
    //                     <input
    //                         type="text"
    //                         value={additionalInfo.model}
    //                         onChange={(e) => setAdditionalInfo({...additionalInfo, model: e.target.value})}
    //                     />
    //
    //                     <label>Year:</label>
    //                     <input
    //                         type="number"
    //                         value={additionalInfo.year}
    //                         onChange={(e) => setAdditionalInfo({...additionalInfo, year: e.target.value})}
    //                     />
    //
    //                     <label>Mileage:</label>
    //                     <input
    //                         type="number"
    //                         value={additionalInfo.mileage}
    //                         onChange={(e) => setAdditionalInfo({...additionalInfo, mileage: e.target.value})}
    //                     />
    //                 </div>
    //             )}
    //             <button type="submit">Create Asset</button>
    //         </form>
    //     </div>
    // );
// };
//
// export default CreatePhysical;